import React, { FC, useEffect, useRef, useState } from 'react';
import { ExternalComponentModel } from './models/externalComponent.model';
import { TExternalComponentProps } from './types/externalComponent.types';
import { googleFormSubmitEvent } from '../../../utils/analytics';
import UnreleasedComponent from '../unreleasedComponent';
import LazySection from '../lazySection';
import { windowService } from '../../../utils/window.utils';

import './index.scss';

const ExternalComponent: FC<TExternalComponentProps> = (props) => {
  const model = new ExternalComponentModel(props);
  const { url, height, visibilityDelay } = model;
  const [iFrameHeight, setiFrameHeight] = useState(height.toString());
  const [isVisible, setIsVisible] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    function messageListener(event: MessageEvent): void {
      if (
        event.origin === new URL(url).origin &&
        event.data &&
        typeof event.data === 'string' &&
        event.data.includes('iframeHeightChange')
      ) {
        const newIFrameHeight = event.data.replace('iframeHeightChange#=###=###=#', '');
        newIFrameHeight && setiFrameHeight(newIFrameHeight);
      }
    }

    windowService().addEventListener('message', messageListener);
    return (): void => {
      windowService().removeEventListener('message', messageListener);
      clearTimeout(timer?.current as ReturnType<typeof setTimeout>);
    };
  }, [url]);

  useEffect(() => {
    function messageListener(event: MessageEvent): void {
      const messageName = 'iframe FormResponse#=###=###=#';
      const delimiter = ',';

      if (event.origin === new URL(url).origin && event.data && typeof event.data === 'string' && event.data.includes(messageName)) {
        const formSubmitData = event.data.replace(messageName, '');
        const dataParts = formSubmitData.split(delimiter);
        const statusCode = dataParts[0];

        if (statusCode === '200') {
          const formName = dataParts[2];
          googleFormSubmitEvent(formName);
        }
      }
    }

    windowService().addEventListener('message', messageListener);

    return (): void => {
      windowService().removeEventListener('message', messageListener);
    };
  }, []);

  // Component is unreleased
  if (model.isUnreleased) {
    return <UnreleasedComponent />;
  }

  const onLoadHandler = (): void => {
    timer.current = setTimeout(() => setIsVisible(true), visibilityDelay);
  };

  const iframeStyle = {
    height: `${iFrameHeight || height}px`,
    opacity: isVisible ? 1 : 0,
  };

  return (
    <LazySection>
      <section className="externalComponent">
        <iframe src={url} style={iframeStyle} onLoad={onLoadHandler} allow="geolocation" title={url}></iframe>
      </section>
    </LazySection>
  );
};

export default ExternalComponent;
